import Entity from 'utilities/entity';

class Notification extends Entity {}

export default new Notification();
